const Hint = ({ className, children }) => (
    <p className={`text-center ${className}`}>
        <small className="text-muted">{children}</small>
    </p>
)

export default Hint